export const Colors = {
    common: {
        white: "#ffffff",
        transparent: "#ffffff00",
        primary: "#C69915",
        secondary: "#27B0E6",
        green: "#32CD32",
        red: "#FF0000",
        twitter: "#1da1f2",
        facebook: "#3B5998"
    },
    light: {
        accent: "#C69915",
        header: "#ffffffb8",
        submenu: "#ffffff80",
        background: "#ffffff",
        backgroundLight: "#f0f0f0",
        border: "#e5e5e5",
        borderDark: "#cccccc",
        textDark: "#1d1d1f",
        textMedium: "#222222",
        textLight: "#888888",
        disabled: "#b4b4b4",
        shadow: "#444444",
        placeholder: "#b4b4b4",
        overlay: "#ffffffc0"
    },
    dark: {
        accent: "#27B0E6",
        header: "#0D0E20",
        submenu: "#00000020",
        background: "#0e0f23",
        backgroundLight: "#0D0E20",
        border: "#ffffff33",
        borderDark: "#666666",
        textDark: "#d5d1cc",
        textMedium: "#cccccc",
        textLight: "#aaaaaa",
        disabled: "#aaaaaa80",
        shadow: "#03080c",
        placeholder: "#666666",
        overlay: "#000000c0"
    }
};
